export default __webpack_public_path__ + "static/national-yards-mobile-56ea7a58653984783b86efd3fc08a861.svg";